import { Box, Hidden } from '@material-ui/core';
import { FC, Fragment } from 'react';
import { CustomTypography } from 'shared/elements/CustomTypography';
import { InfoItemProps } from '../InfoItem';
import { disableStyle } from 'shared/utils/disableStyling';
import { Progress } from 'components/MyInfo/Progress/Progress';
import { ListVariantItemContainer } from './ListVariantItem.styles';
import { ActionButtons } from '../ActionButtons/ActionButtons';
import { Skeleton } from '@material-ui/lab';

const ListVariantItem: FC<InfoItemProps> = ({
  info,
  attached_media,
  onEdit,
  onDelete,
  onView,
  isSaving = false,
  isEditing = false,
  isDeleting = false,
}) => {
  const commonStyle = disableStyle(isSaving, isEditing, isDeleting);
  const primary_image = attached_media
    ? attached_media[0]?.attributes?.modified_attachment_url ||
      attached_media[0]?.attributes?.cropped_attachment_url ||
      attached_media[0]?.attributes?.attachment_url ||
      ''
    : '';

  return (
    <ListVariantItemContainer>
      <Hidden mdDown>
        <Box style={{ width: '100%', height: '100%', cursor: 'pointer' }} onClick={onView}>
          <Box style={{ ...commonStyle, display: 'flex', gap: 10, height: 30, alignItems: 'center' }}>
            {info?.map((i, index) => (
              <Box style={{ flex: 1, display: 'flex', gap: 10, alignItems: 'center' }} key={i.name}>
                <Box style={{ aspectRatio: '16/9', width: 'auto', height: 30, flexShrink: 0 }}>
                  {index === 0 ? (
                    primary_image ? (
                      <img src={primary_image} style={{ width: '100%', height: '100%', borderRadius: 4 }} />
                    ) : (
                      <Skeleton
                        variant="rect"
                        width={'100%'}
                        height={'100%'}
                        animation={false}
                        style={{ borderRadius: 4 }}
                      />
                    )
                  ) : (
                    <Fragment />
                  )}
                </Box>

                <span style={{ fontSize: 14, fontWeight: 500 }}>{i.name ? `${i.name}:` : ''}</span>
                <CustomTypography style={{ fontSize: 14 }}>{i.details}</CustomTypography>
              </Box>
            ))}

            <Box style={{ display: 'flex', justifyContent: 'end', flex: 1 }}>
              {isSaving || isEditing || isDeleting ? (
                <Progress isDeleting={isDeleting} />
              ) : (
                <ActionButtons onDelete={onDelete} onEdit={onEdit} isDisabled={isSaving || isEditing || isDeleting} />
              )}
            </Box>
          </Box>
        </Box>
      </Hidden>

      <Hidden lgUp>
        <Box
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            ...commonStyle,
            cursor: 'pointer',
          }}
          onClick={onView}
        >
          <Box>
            <CustomTypography fontSize={14}>{info[0].details}</CustomTypography>
            <CustomTypography fontSize={14}>
              {info[1].details + ' ' + info[2].details}{' '}
              {info[3] && info[3]?.name?.toLowerCase() === 'age' ? info[3].details : ''}
            </CustomTypography>
          </Box>
          {isSaving || isEditing || isDeleting ? (
            <Progress isDeleting={isDeleting} />
          ) : (
            <ActionButtons onDelete={onDelete} onEdit={onEdit} isDisabled={isSaving || isEditing || isDeleting} />
          )}
        </Box>
      </Hidden>
    </ListVariantItemContainer>
  );
};

export default ListVariantItem;
